"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var roundToXDecimalPlaces = exports.roundToXDecimalPlaces = function roundToXDecimalPlaces(numberOfPlaces, n) {
  return Number(n.toFixed(numberOfPlaces));
};

var roundToZeroDecimalPlaces = exports.roundToZeroDecimalPlaces = function roundToZeroDecimalPlaces(n) {
  return roundToXDecimalPlaces(0, n);
};

var roundToTwoDecimalPlaces = exports.roundToTwoDecimalPlaces = function roundToTwoDecimalPlaces(n) {
  return roundToXDecimalPlaces(2, n);
};